module.exports = __webpack_public_path__ + "img/product-reviews-05.f9ae9ec6.png";